// AUTO-GENERATED by tools/generate-parallel.mjs --world 7. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 7
// W7 (Aurora) — third paid-tier world. Long chains, rolling clears.
// // Depth 7-9 ramp; 5 colors; r=3 geometry.
import type { LevelDef } from '@tessera/engine';

export const WORLD_7_GENERATED: LevelDef[] = [
  // d*=7  branching=16.66  D=0.030  tiles=12
  {
    id: 'w7-l01',
    world: 7,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 3 },
    { coord: { q: 3, r: -3 }, color: 3 },
    ],
  },
  // d*=7  branching=18.29  D=0.036  tiles=12
  {
    id: 'w7-l02',
    world: 7,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 2, r: -3 }, color: 3 },
    ],
  },
  // d*=7  branching=19.24  D=0.039  tiles=13
  {
    id: 'w7-l03',
    world: 7,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 3 },
    { coord: { q: 3, r: -2 }, color: 3 },
    ],
  },
  // d*=7  branching=19.73  D=0.041  tiles=13
  {
    id: 'w7-l04',
    world: 7,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 3 },
    { coord: { q: -1, r: 3 }, color: 3 },
    ],
  },
  // d*=7  branching=20.31  D=0.043  tiles=12
  {
    id: 'w7-l05',
    world: 7,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 3 },
    { coord: { q: -1, r: -2 }, color: 3 },
    ],
  },
  // d*=7  branching=20.97  D=0.045  tiles=15
  {
    id: 'w7-l06',
    world: 7,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 3, r: -2 }, color: 3 },
    { coord: { q: -3, r: 1 }, color: 4 },
    { coord: { q: -3, r: 2 }, color: 4 },
    ],
  },
  // d*=7  branching=22.04  D=0.049  tiles=12
  {
    id: 'w7-l07',
    world: 7,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -1, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 3 },
    { coord: { q: -2, r: -1 }, color: 3 },
    ],
  },
  // d*=7  branching=16.32  D=0.058  tiles=12
  {
    id: 'w7-l08',
    world: 7,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 3 },
    { coord: { q: 3, r: -3 }, color: 3 },
    ],
  },
  // d*=7  branching=20.79  D=0.133  tiles=12
  {
    id: 'w7-l09',
    world: 7,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 3 },
    { coord: { q: -2, r: 3 }, color: 3 },
    ],
  },
  // d*=8  branching=20.96  D=0.326  tiles=13
  {
    id: 'w7-l10',
    world: 7,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 3 },
    { coord: { q: 0, r: 3 }, color: 3 },
    ],
  },
];
